import React, { useState } from "react";
import styled from "styled-components";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Search = () => {
  const [input, setInput] = useState("");
  const navigate = useNavigate();
  const submitHandler = (e) => {
    e.preventDefault();
    if (!input) {
      navigate("/");
    } else {
      navigate("/searched/" + input);
    }
  };

  return (
    <Form onSubmit={submitHandler}>
      <div>
        <FaSearch />
        <input
          type="search"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>
    </Form>
  );
};

const Form = styled.form`
  margin: 0rem auto;
  margin-top: 5rem;
  width: 400px;
  div {
    width: 100%;
    position: relative;
    input {
      border: none;
      background: linear-gradient(35deg, #494949, #313131);
      color: white;
      font-size: 1rem;
      padding: 0.6rem 3rem;
      border: none;
      border-radius: 1rem;
      outline: none;
      width: 100%;
    }
    svg {
      position: absolute;
      top: 50%;
      left: 0%;
      transform: translate(100%, -50%);
      color: white;
    }
  }
  @media screen and (max-width: 800px) {
    width: 300px;
    div {
      input {
        padding: 0.4rem 3rem;
      }
    }
  }
  @media screen and (max-width: 400px) {
    width: 250px;
  }
`;
export default Search;
